var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2418_1706)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.172 15.829C12.017 19.674 15.58 20.095 16.626 20.134C17.89 20.18 19.18 19.148 19.738 18.091C18.848 17.047 17.689 16.237 16.42 15.359C15.671 16.107 14.748 17.497 13.519 16.999C12.82 16.718 11.094 15.923 9.586 14.414C8.077 12.906 7.283 11.18 7 10.482C6.502 9.25097 7.896 8.32597 8.645 7.57697C7.767 6.28697 6.971 5.09797 5.929 4.25297C4.857 4.81297 3.819 6.09297 3.866 7.37397C3.905 8.41997 4.326 11.983 8.172 15.829ZM16.552 22.133C15.112 22.08 11.031 21.516 6.757 17.243C2.484 12.969 1.921 8.88897 1.867 7.44797C1.787 5.25197 3.469 3.11897 5.412 2.28597C5.64598 2.18494 5.9022 2.14647 6.15553 2.17435C6.40886 2.20222 6.65059 2.29548 6.857 2.44497C8.465 3.61797 9.574 5.39497 10.527 6.78697C10.7252 7.07642 10.8161 7.42607 10.7837 7.77542C10.7514 8.12476 10.598 8.45181 10.35 8.69997L8.994 10.057C9.309 10.752 9.95 11.95 11 13C12.05 14.05 13.248 14.691 13.944 15.006L15.299 13.65C15.5481 13.4015 15.8765 13.2482 16.227 13.217C16.5775 13.1857 16.9278 13.2784 17.217 13.479C18.637 14.463 20.305 15.556 21.521 17.113C21.6826 17.3209 21.7854 17.5684 21.8187 17.8296C21.8519 18.0908 21.8144 18.3562 21.71 18.598C20.873 20.551 18.755 22.214 16.552 22.133Z",
    fill: "#673C8E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2418_1706"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.106a1abb1592b3ea64237f222be927b5.svg";
export { ForwardRef as ReactComponent };